import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const includedItems = ['2 professional cleanings per year', '2 regular exams per year', '1 set of X-rays per year', '1 emergency exam per year', 'Oral cancer screening', 'Full mouth digital scan and assessment', 'Intraoral and professional photos', '20% off all other dental treatments', '10% discount on membership fees for additional family members'];
export function Included() {
  return <section className="py-12 lg:py-32 bg-brand-dark" data-id="element-152">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-153">
        <div className="bg-brand-card rounded-2xl lg:rounded-[2.5rem] border border-brand-border p-6 md:p-16 lg:p-20" data-id="element-154">
          <div className="text-center mb-8 lg:mb-16" data-id="element-155">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8,
            ease: 'easeOut'
          }} className="text-2xl md:text-4xl lg:text-5xl font-light mb-3 lg:mb-6 text-white tracking-tight" data-id="element-156">
              What's included in the VIP Plan?
            </motion.h2>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1,
            duration: 0.8,
            ease: 'easeOut'
          }} className="text-brand-muted text-base lg:text-lg font-light max-w-2xl mx-auto" data-id="element-157">
              Everything you need to maintain a healthy smile year-round, plus
              exclusive discounts on additional care.
            </motion.p>
          </div>

          <ul className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-4 lg:gap-y-8" data-id="element-158">
            {includedItems.map((item, index) => <motion.li key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.05,
            duration: 0.5
          }} className="flex items-start space-x-4" data-id="element-159">
                <div className="mt-1 bg-white/10 p-1 rounded-full flex-shrink-0" data-id="element-160">
                  <Check className="w-4 h-4 text-white" strokeWidth={2} data-id="element-161" />
                </div>
                <span className="text-white/90 font-light text-base lg:text-lg" data-id="element-162">
                  {item}
                </span>
              </motion.li>)}
          </ul>

          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.5,
          duration: 0.8
        }} className="mt-8 lg:mt-16 pt-6 lg:pt-8 border-t border-brand-border text-center" data-id="element-163">
            <p className="text-sm text-brand-muted font-light" data-id="element-164">
              *The 20% discount applies to all other treatments offered at Lima
              Dental Group, ensuring your complete care is always affordable.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}